// A throwaway random id — kept free of uuid-by-string (js-md5/js-sha1) so the eager store graph
// (slices/chats imports this) doesn't pull hashing libs into the main chunk. The deterministic,
// hash-based id lives in utils/hashUuid. Falls back to an RFC-4122 v4 from getRandomValues for
// browsers without crypto.randomUUID (Chrome <92 / Safari <15.4), which core-js doesn't polyfill.
export const getRandomUuid = () => {
  if (crypto.randomUUID) return crypto.randomUUID();

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`;
};
